import axios from 'axios';
import { EventBus } from '../event/event-bus.js';
import router from '.././router';

const apiUrl = `${window.location.origin}/api`;

const client = axios.create({
    baseURL: apiUrl,
    json: true
})

export default {
    async execute(method, resource, data, accessToken) {
        return await client({
            method,
            url: resource,
            data,
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        }).then(req => {
            return req.data
        }).catch((error) => {
            if (error.response) {
                if (error.response.status === 403) {
                    router.push({ name: 'Unauthorized' });
                    return;
                } else if (error.response.status === 401) {
                    location.reload();
                    return;
                }
            }
            EventBus.$emit('emit-error', error.response.data);
        })
    },
    async getReports(accessToken) {
        return await this.execute('get', `/report`, null, accessToken);
    },
    async getLineChart(request, accessToken) {
        return await this.execute('post', `/report/line/preview`, request, accessToken);
    },
    async getWordCloudChart(request, accessToken) {
        return await this.execute('post', `/report/wordcloud/preview`, request, accessToken);
    },
    async getPieChart(request, accessToken) {
        return await this.execute('post', `/report/pie/preview`, request, accessToken);
    },
    async getTableChart(request, accessToken) {
        return await this.execute('post', `/report/table/preview`, request, accessToken);
    },
    async getUniqueSourceItems(reportTableColumnId, accessToken) {
        return await this.execute('get', `/report/column/types?reportTableColumnId=${reportTableColumnId}`, null, accessToken);
    },
    async getWordCloudReportByChartId(chartId, chartRequest, accessToken) {
        return await this.execute('post', `/report/wordcloud/${chartId}`, chartRequest, accessToken);
    },
    async getPieReportByChartId(chartId, chartRequest, accessToken) {
        return await this.execute('post', `/report/pie/${chartId}`, chartRequest, accessToken);
    },
    async getLineReportByChartId(chartId, chartRequest, accessToken) {
        return await this.execute('post', `/report/line/${chartId}`, chartRequest, accessToken);
    },
    async getTableReportByChartId(chartId, chartRequest, accessToken) {
        return await this.execute('post', `/report/table/${chartId}`, chartRequest, accessToken);
    },
    async getPostSevDetailsByIncidentId(incidentId, accessToken) {
        return await this.execute('get', `/report/postSev/${incidentId}`, null, accessToken);
    },
    async getSevImactDetailsByIncidentId(incidentId, accessToken) {
        return await this.execute('get', `/report/sevImpact/${incidentId}`, null, accessToken);
    },
    async getSevImactLogDetailsByIncidentId(incidentId, accessToken) {
        return await this.execute('get', `/report/sevImpactLog/${incidentId}`, null, accessToken);
    },
    async getElasticInfoDetailsByIncidentId(incidentId, accessToken) {
        return await this.execute('get', `/report/elasticInfo/${incidentId}`, null, accessToken);
    },
    async getPagerDutyDetailsByIncidentId(incidentId, accessToken) {
        return await this.execute('get', `/report/pagerDuty/${incidentId}`, null, accessToken);
    },
    async getPbiDetailsByIncidentId(incidentId, accessToken) {
        return await this.execute('get', `/report/pbi/${incidentId}`, null, accessToken);
    },
    async getRemedyDetailsByIncidentId(incidentId, accessToken) {
        return await this.execute('get', `/report/remedy/${incidentId}`, null, accessToken);
    },
    async searchAutoRemovedHistory(accessToken, searchText, pageNo, pageSize, orderBy, sorting, startDate, endDate) {
        return await this.execute('get', `/report/autoRemoved/search?pageNo=${pageNo}&pageSize=${pageSize}&searchText=${searchText}&orderBy=${orderBy}&sorting=${sorting}&startDate=${startDate}&endDate=${endDate}`, null, accessToken);
    },
}
